import { isZodError } from "@goodfill/domain-properties-zod-validators";
import z from "zod";

// rome-ignore lint/suspicious/noExplicitAny: type is not important, we get only error messages
export const zodErrorsToString = (validation: z.SafeParseReturnType<any, any>): string[] =>
  isZodError(validation) ? validation.error.errors.map((e) => e.message) : [];
